import React from 'react';

const ProfileContext = React.createContext();
ProfileContext.displayName = 'ProfileContext';

export default ProfileContext;